export const NAME = 'drillingMachines';